import React from "react";
import styled from "styled-components";

import { ButtonPrimaryLink, ButtonSecondaryLink } from "@components/Button";
import Layout from "@components/Layout";

import { Row } from "@styles/grid";

import { getAllBundles } from "@actions/bundles.action";
import BundlesTable from "./BundlesTable";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem auto 5.5rem;
  max-width: 125rem;
  width: 100%;
  padding: 0 2.5rem;
`;

const Bundles = () => {
  const dispatch = useDispatch();
  const { all: bundles } = useSelector(({ bundles }) => bundles);

  useEffect(() => {
    (async () => {
      const bundlesNotEmpty = bundles && bundles.length;

      if (!bundlesNotEmpty) {
        await dispatch(getAllBundles());
      }
    })();
  }, [bundles]);

  return (
    <Layout pageTitle="Bundles">
      <Content>
        <Row justify="space-between" margin="2rem 0">
          <ButtonSecondaryLink outlined uppercase href="/">
            Back to Dashboard
          </ButtonSecondaryLink>
          <ButtonPrimaryLink uppercase href="/bundles/add">
            Add bundle
          </ButtonPrimaryLink>
        </Row>
        <BundlesTable />
      </Content>
    </Layout>
  );
};

export default Bundles;
